import { useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import { PERSON_BY_ID_QUERY } from "../../../../../api/person/queries";
import { defaultPersonKursistColumns } from "../../../../../config/person";
import {
  createColumnEditorTrigger,
  getHeaderActiveColumns,
  TD,
} from "../../../../../util/table";
import { tableToXLSX } from "../../../../../util/tableExportUtils";
import ButtonDownload from "../../../../ButtonDownload";
import { ModalProvider } from "../../../../Modal/Modal";
import {
  TableBody,
  TableHead,
  TableRoot,
  TableRow,
} from "../../../../Table/TableBasic";
import ColumnEditorModal from "@/components/column-editor/ColumnEditorModal";
import IngenRegistreringer from "../IngenRegistreringer";
import { KursusPerson, PersonDto } from "../../../../../interfaces/schema";
import { PersonKursistField } from "../../../../../interfaces/personer";
import { SortBy, IColumn } from "../../../../../interfaces/table";
import useLocalStorageState from "use-local-storage-state";
import { orderBy } from "../../../../../util/orderBy";

/**
 * Brugt af FMU-kurser og Andre arrangementer
 * @param props
 * @returns
 */
export default function PersonKursist({
  personKursist,
  personKursistColumns,
  setPersonKursistActiveColumns,
  invalidateData,
  localStorageSortKey,
}: {
  personKursist: KursusPerson[];
  personKursistColumns: IColumn<PersonKursistField>[];
  setPersonKursistActiveColumns: React.Dispatch<
    React.SetStateAction<PersonKursistField[]>
  >;
  invalidateData: InvalidateDataFunction<any>;
  localStorageSortKey: string;
}) {
  const [sortBy, setSortBy] = useLocalStorageState<SortBy[]>(
    localStorageSortKey,
    {
      defaultValue: defaultSortBy,
    },
  );
  const params = useParams();
  const { id } = params;

  const { data } = useQuery<{
    person: PersonDto;
  }>(PERSON_BY_ID_QUERY(), {
    variables: { id },
  });

  // event handlers
  function downloadHandler() {
    tableToXLSX(personKursistColumns, personKursist, {
      fileName: `fmukurser-for-${data?.person.kundeNr}`,
      additionalData: {
        kundenr: data?.person.kundeNr,
      },
    });
  }

  if (!personKursist || !personKursist.length) {
    return <IngenRegistreringer invalidateData={invalidateData} />;
  }
  return (
    <>
      <ButtonDownload onClick={downloadHandler} />
      <ModalProvider>
        <TableRoot>
          <TableHead ColumnEditorTrigger={createColumnEditorTrigger()}>
            <>
              {getHeaderActiveColumns(personKursistColumns, {
                defaultSortBy,
                setSortBy,
                sortBy,
              })}
            </>
          </TableHead>
          <TableBody>
            {orderBy(
              personKursist,
              sortBy.map((s) => s.field),
              sortBy.map((s) => s.direction),
            ).map((kursist, i) => {
              return (
                <TableRow key={i} invalidateData={invalidateData}>
                  <>
                    {personKursistColumns
                      .filter((col) => col.active)
                      .map((col) => {
                        return (
                          <TD key={col.field} col={col} rowData={kursist} />
                        );
                      })}
                  </>
                </TableRow>
              );
            })}
          </TableBody>
        </TableRoot>
        <ColumnEditorModal
          defaultColumns={defaultPersonKursistColumns}
          columns={personKursistColumns}
          setActiveColumns={setPersonKursistActiveColumns}
        />
        <div className="py2-">&nbsp;</div>
      </ModalProvider>
    </>
  );
}

const defaultSortBy: SortBy[] = [
  {
    direction: "desc",
    field: "hold.fraDato",
  },
];
